export default {"src":"/_next/static/media/panelles_bold.a085c5b9.svg","height":24,"width":24};